import React from 'react';
import { Box, Image, Flex } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import logo from '../assets/logo.png';

const MotionBox = motion(Box);

const LogoPulseLoader = () => {
    return (
        <Flex
            justifyContent="center"
            alignItems="center"
            h="100%"
            w="100%"
            minH="200px" // Ensure it takes up space
        >
            <MotionBox
                animate={{
                    scale: [1, 1.1, 1],
                    opacity: [0.8, 1, 0.8]
                }}
                transition={{
                    duration: 2,
                    repeat: Infinity,
                    ease: "easeInOut"
                }}
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                <Image
                    src={logo}
                    alt="Loading..."
                    boxSize="100px" // Adjust size as needed
                    objectFit="contain"
                />
            </MotionBox>
        </Flex>
    );
};

export default LogoPulseLoader;
